import {Component, ViewEncapsulation} from "@angular/core";

@Component({
  standalone: true,
  templateUrl: './contact.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['contact.component.css']
})

export class ContactComponent {
  constructor() {
  }
}
